import type { UcTestimonialSection } from '../../../lib/useCaseQueries';
import { UseCaseBand, UseCaseSceneSlug } from '../primitives';

type UcTestimonialSectionProps = {
  data: UcTestimonialSection;
  tone: 'light' | 'dark';
};

export function UcTestimonialSection({ data, tone }: UcTestimonialSectionProps) {
  return (
    <UseCaseBand tone={tone} id="testimonial" className="uc-testimonial-section">
      <UseCaseSceneSlug sceneNumber={data.sceneNumber} sceneLabel={data.sceneLabel} />
      <div className="uc-testimonial reveal">
        <div className="uc-testimonial-mark" aria-hidden="true">
          &ldquo;
        </div>
        {data.quote && <blockquote className="uc-testimonial-quote">{data.quote}</blockquote>}
        {(data.attribution || data.role) && (
          <cite className="uc-testimonial-attribution">
            {data.attribution && <span className="uc-testimonial-name">{data.attribution}</span>}
            {data.attribution && data.role && (
              <span className="uc-testimonial-sep" aria-hidden="true">
                /
              </span>
            )}
            {data.role && <span className="uc-testimonial-role">{data.role}</span>}
          </cite>
        )}
      </div>
    </UseCaseBand>
  );
}
